import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight } from 'lucide-react';

const NU_LINK = 'https://nubank.com.mx/mgm/?id=gbdtmPvm_ty4imKDyDDzgQ&msg=35985&utm_channel=referral&utm_medium=whatsapp&utm_source=mgm&mgm-campaign=mgm-cash-rewards';

const NubankInvite = ({ theme = 'dark' }) => {
  const isLight = theme === 'light';
  return (
    <Card
      className={`${isLight ? 'bg-gradient-to-r from-[#820ad1]/10 to-purple-100 border-[#820ad1]/30' : 'card-viubux-dark border-[#820ad1]/40 bg-gradient-to-r from-[#820ad1]/15 to-purple-600/5'}`}
      data-testid="nubank-invite"
    >
      <CardContent className="p-5">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-full bg-[#820ad1] flex items-center justify-center flex-shrink-0 gotham-bold text-white text-base">
            NU
          </div>
          <div className="flex-1">
            <p className={`gotham-bold text-sm mb-1 ${isLight ? 'text-gray-900' : 'text-white'}`}>
              Viubux y Nubank (NU) se han afiliado 💜
            </p>
            <p className={`verdana-regular text-sm mb-3 ${isLight ? 'text-gray-600' : 'text-white/70'}`}>
              Te sugerimos ampliamente abrir una cuenta en <span className={`font-semibold ${isLight ? 'text-gray-900' : 'text-white'}`}>Nubank (NU)</span> para recibir tus pagos de forma rápida y sin comisiones. Es gratis y se abre en minutos.
            </p>
            <a
              href={NU_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nubank-invite-link"
              className="inline-flex items-center gap-2 bg-[#820ad1] hover:bg-[#6d09b0] text-white gotham-medium text-sm px-4 py-2 rounded-lg transition-colors"
            >
              Abrir mi cuenta NU
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NubankInvite;
